if (!customElements.get('login-page')) {
  class Login extends HTMLElement {
    constructor() {
      super();
      this.login_header = this.dataset.loginHeader;
      this.signup_header = this.dataset.signupHeader;
      this.forgot_header = this.dataset.forgotHeader;
    }

    connectedCallback() {
      this.addDelegatedClickListeners();
    }

    addDelegatedClickListeners() {
      window.addEventListener('click', (e) => {
        const clicked_element = e.target.closest('[data-account-action]');

        if (!clicked_element) return;
        
        const { 
          accountAction: action,
          accountTarget: target,
        } = clicked_element.dataset;

        switch (action) {
          case 'toggle-section':  
            const drawer_header = this.querySelector('[data-drawer-header]');
            const signup_subheader = this.querySelector('[data-signup-subheader]');
            const toggles_container = this.querySelector('[data-button-toggles]');

            [...this.querySelectorAll('[data-account-action]')].forEach(btn => {
              btn.dataset.target === target ? btn.setAttribute('disabled', true) : btn.removeAttribute('disabled', true); 
            });
            [...this.querySelectorAll('[data-account-section]')].forEach(section => {
              section.dataset.accountSection === target ? section.classList.remove('hidden') : section.classList.add('hidden'); 
            });

            if (target === 'register') {
              drawer_header.innerHTML = this.signup_header;
              signup_subheader.classList.remove('hidden');
              toggles_container.classList.remove('hidden');
            } else if (target === 'forgot-password') {
              drawer_header.innerHTML = this.forgot_header;
              signup_subheader.classList.add('hidden');
              toggles_container.classList.add('hidden');
            } else {
              drawer_header.innerHTML = this.login_header;
              signup_subheader.classList.add('hidden');
              toggles_container.classList.remove('hidden');
            }
          break;
          default: break;
        }
      })
    }
  }

  customElements.define('login-page', Login);
}